<ion-button (click)="reactivate()"
            shape="round"
            icon-only
            class="list-button"
            [class.reactivated]="delivery?.resendRequested">
  <i class="fas fa-upload icon"></i>
</ion-button>
